import { Payments } from "@/constants";
import { Button, CapsuleTabs, Tabs } from "antd-mobile";
import { useState } from "react";
import styles from './index.module.scss';

const dealInfoList = [
  { key: '1', title: '币安(binance)', img: 'images/bourse1.png' },
  { key: '2', title: '欧易(okx)', img: 'images/bourse2.png' },
  { key: '3', title: '芝麻开门(gate)', img: 'images/bourse3.png' },
]

const DealHelp = () => {
  const [key, setKey] = useState<string>('1');
  return <div>
    <div className={styles.dealinfo}>
      <CapsuleTabs activeKey={key} onChange={setKey}>
        {dealInfoList.map((help) => {
          return <CapsuleTabs.Tab title={help.title} key={help.key} />;
        })}
      </CapsuleTabs>
    </div>
    <div>
      {
        dealInfoList.filter(item => item.key === key).map(item => {
          return item.img ? (<img key={item.key} alt="" src={item.img} style={{ width: '100%' }} />) : ''
        })
      }
    </div>

  </div>
}

export type HelpStep = {
  title: string;
  img: string;
  desc?: string | React.ReactNode;
};
export type HelpContent = {
  title: string;
  steps: HelpStep[];
};

export const data: Record<string, HelpContent> = {
  "1": {
    title: "实名认证教程",
    steps: [
      {
        title: "开始实名认证",
        desc: "点击首页「我的」进入用户中心，点击「实名认证」",
        img: "images/helps/images/sm1.png"
      },
      { title: "上传实名资料-完成实名验证", img: "images/helps/images/sm2.png" },
    ],
  },
  "2": {
    title: "添加收付款教程",
    steps: [
      { title: "添加收付款信息", img: "images/helps/images/sf1.png" },
      {
        title: "完善信息",
        img: "images/helps/images/sf2.png",
        desc: "完善收付款信息后点击「确认添加」即可",
      },
    ],
  },
  "3": {
    title: "卖币教程",
    steps: [
      { title: "首页-点击「卖币」", img: "images/helps/images/m1.png" },
      {
        title: "完善出售信息",
        img: "images/helps/images/m2.png",
        desc: "完善出售信息后，点击「发布挂单」即可",
      },
      {
        title: "确认开始交易",
        img: "images/helps/images/m3.png",
        desc: "有买家发起购买后，点击「开始交易」即可",
      },
    ],
  },
  "4": {
    title: "买币教程",
    steps: [
      { title: "首页-点击「买币」", img: "images/helps/images/mb1.png" },
      {
        title: "挂单市场点击需要购买的挂单",
        img: "images/helps/images/mb2.png",
        desc: "注意挂单所支持的收款方式",
      },
      {
        title: "确认购买信息",
        img: "images/helps/images/mb3.png",
        desc: "确认购买数量，支付方式，点击「确认购买」即可",
      },
      {
        title: "等待卖家确认订单",
        img: "images/helps/images/mb4.png",
        desc: "提交购买订单后，等待卖家确认订单开始交易",
      },
      {
        title: "确认信息完成转账",
        img: "images/helps/images/mb5.png",
        desc: "完成转账，点击「我已转账」等待卖家打币即可，如有纠纷请点击「申请客服介入」",
      },
    ],
  },
  "5": {
    title: "充值教程",
    steps: [
      {
        title: "内嵌VipPay充值",
        img: "images/helps/images/cz1.png",
        desc: "在合作平台选择「我的VipPay充值」填写金额，输入资金密码，即可完成秒充值",
      },
      {
        title: "VipPay钱包App充值",
        img: "",
        desc: (
          <>
            <div className="wrapper">
              <div className="describe">
                1 ）在合作平台选择VipPay充值，填写/选择快捷金额后确认提交
              </div>
              <img key="c1" alt="" style={{ width: "90%" }} src="images/helps/images/cz2.png" />
            </div>
            <div className="head">2 ）在跳转页面使用VipPay钱包App扫码或点击「打开VipPay钱包」</div>
            <img key="c1" alt="" style={{ width: "90%" }} src="images/helps/images/cz3.png" />
            <div className="head">3 ）输入您的资金密码，完成充值</div>
            <img key="c1" alt="" style={{ width: "90%" }} src="images/helps/images/cz4.png" />
          </>
        ),
      },
    ],
  },

  "6": {
    title: "提现教程",
    steps: [
      {
        title: "添加VipPay钱包地址",
        desc: "在合作平台添加VipPay钱包地址为您的提款地址",
        img: "images/helps/images/tx1.png"
      },
      {
        title: "复制VipPay钱包地址",
        img: "images/helps/images/tx2.png",
        desc: "VipPay钱包首页，如下图所示点击复制按钮",
      },
      {
        title: "粘贴VipPay钱包地址",
        img: "images/helps/images/tx3.png",
        desc: "将复制的VipPay钱包地址粘贴至合作平台",
      },
      {
        title: "提款至VipPay钱包",
        img: "images/helps/images/tx4.png",
        desc: "在合作平台成功添加VipPay钱包地址后即可完成秒提款",
      },
    ],
  },
  "7": {
    title: "交易所交易教程",
    steps: [
      {
        title: "",
        img: "",
        desc: (
          <DealHelp />
        ),
      },
    ],
  },
};

export const paymentsContent: Record<string, HelpContent> = {
  [`${Payments.WE_CHAT}`]: {
    title: "如何保存微信收款码",
    steps: [
      {
        title: "第一步",
        img: "images/helps/images/wechat/a@2x.png",
        desc: "进入微信，点击底部【服务】，点击【收付款】",
      },
      {
        title: "第二步",
        img: "images/helps/images/wechat/b@2x.png",
        desc: "点击【二维码收款】",
      },
      {
        title: "第三步",
        img: "images/helps/images/wechat/c@2x.png",
        desc: "点击【保存收款码】",
      },
    ],
  },
  [`${Payments.ALI}`]: {
    title: "如何保存支付宝收款码",
    steps: [
      {
        title: "第一步",
        img: "images/helps/images/ali/a@2x.png",
        desc: "进入支付宝，点击【收付款】",
      },
      {
        title: "第二步",
        img: "images/helps/images/ali/b@2x.png",
        desc: "点击【二维码收款】",
      },
      {
        title: "第三步",
        img: "images/helps/images/ali/c@2x.png",
        desc: "点击【保存收款码】",
      },
    ],
  },
};

// <template>
//   <div class="page page-receive-code">
//     <div class="content">
//       <template v-if="isWechat">
//         <div class="head">一.第一步</div>
//         <div class="describe">进入微信，点击底部【服务】，点击【收付款】</div>
//         <img key="s1" alt="" src="assetsimages/helps/wechat/a@2x.png"/>
//         <div class="head">二.第二步</div>
//         <div class="describe">点击【二维码收款】</div>
//         <img key="s2" alt="" src="assetsimages/helps/wechat/b@2x.png"/>
//         <div class="head">三.第三步</div>
//         <div class="describe">点击【保存收款码】</div>
//         <img key="s3" alt="" src="assetsimages/helps/wechat/c@2x.png"/>
//       </template>
//       <template v-else>
//         <div class="head">一.第一步</div>
//         <div class="describe">进入支付宝，点击【收付款】</div>
//         <img key="s1" alt="" src="assets/images/ali/a@2x.png"/>
//         <div class="head">二.第二步</div>
//         <div class="describe">点击【二维码收款】</div>
//         <img key="s2" alt="" src="assets/images/ali/b@2x.png"/>
//         <div class="head">三.第三步</div>
//         <div class="describe">点击【保存收款码】</div>
//         <img key="s3" alt="" src="assets/images/ali/c@2x.png"/>
//       </template>
//     </div>
//   </div>
// </template>

// <script>
// export default {
//   computed: {
//     isWechat() {
//       return this.$route.params.isWechat;
//     },
//   },
//   created() {
//     this.$root.$emit("root:set-topbar", ["left-back"]);
//     this.$root.$emit(
//       "root:set-title",
//       this.isWechat ? "如何保存微信收款码？" : "如何保存支付宝收款码？"
//     );
//   },
// };
// </script>

// <style lang="scss">
// .page.page-receive-code {
//   overflow-y: auto;

//   .content {
//     padding: 15px;
//   }

//   .title {
//     text-align: center;
//     font-size: 15px;
//     font-weight: 600;
//     padding: 8px 0;
//   }

//   .head {
//     font-size: 15px;
//     font-weight: 600;
//     position: relative;
//     margin: 15px 0;

//     &::after {
//       display: block;
//       content: "";
//       width: 80px;
//       height: 5px;
//       background: linear-gradient(180deg, #dee9ff, #8362ff);
//     }
//   }

//   img {
//     width: 300px;
//     display: block;
//     margin: 0 auto;
//   }

//   .wrapper {
//     display: flex;
//   }

//   .describe {
//     font-size: 11px;
//     color: #999999;
//     padding: 0 0 10px;
//   }
// }
// </style>
